/* eslint-disable react-hooks/exhaustive-deps */
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { dataEditorDefault } from "pages/project-component-detail/types"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { STATUS_RESPONSE } from "types"
import {
  postProjectCommentMiddleware,
} from "../api.services"
import FormInputEditorCard from "../molecules/FormInputEditorCard"
import { useAdditionalAndExtraInfoProjectBuild } from "../project-build.hook"
import { ProjectBuildCommentDetail } from "../project-build.type"
import { useUploadFileWorkerController } from "workers/uploadFileWorkerController"
import { configureStore } from "stores/configureStore"
import { closeLoading, startLoading } from "reducers/loading"
import { includes, isEmpty } from "lodash"
import { useBoolean, useString, useWindowSize } from "helpers/hooks"
import { v4 as uuid } from "uuid"
import { CommentBuildItemCard } from "../molecules/CommentBuildItemCard"
import { useAppSelector } from "hooks/useApp"
import Tippy from "@tippyjs/react"
import IconEditorDeleteFile from "assets/images/icons/icon-editor-delete-file.svg"
import ModalCustom from "components/ModalCustom"
import { ACTION_MODAL } from "components/ModalCustom/types"
import InputDefault from "components/Input/InputDefault"
import CheckedDefault from "components/Checked/CheckedDefault"
import { ReactComponent as IconSearchNormal } from "assets/images/icons/icon-search-normal.svg"
import Button from "components/Button/Button"

interface Props {
  comments: ProjectBuildCommentDetail[]
  idProjectBuild: string
  isEditorInput: boolean
  updateWhenCreateComment: () => void
  isDeleted?: boolean
  subNameDownload: string
  loadMoreComments?: (commentFromId?: string) => void
  hasMoreComments?: boolean
  isLoadingMore?: boolean
  approvers: {
    id: string
    email: string
    fullname: string
    avatar: string | null
  }[]
  commentsPage: number
  isOwner: boolean
}
const CommentsCard = (props: Props) => {
  const {
    comments,
    idProjectBuild,
    isEditorInput,
    updateWhenCreateComment,
    isDeleted,
    subNameDownload,
    loadMoreComments,
    hasMoreComments,
    isLoadingMore,
    approvers,
    commentsPage,
    isOwner
  } = props
  const {
    dataEditor,
    isLoading,
    isScroll,
    keyInputFile,
    ref,
    listFileAdd,
    setDataEditor,
    fileSelectedHandler,
    handleChangeEditor,
    handleDeleteFileNoDownload,
    setListFileAdd,
    handleChangeScroll,
    clearStorageWhenSubmit,

  } = useAdditionalAndExtraInfoProjectBuild("comments", idProjectBuild)
  const userInfo = useAppSelector((state) => state.userInfo)
  const { isMobile } = useWindowSize()
  const { workerUploadFile } = useUploadFileWorkerController()
  const [selectedApprove, setSelectedApprove] = useState<string[]>([])
  const openAddApprovalModal = useBoolean(false)
  const searchApproveModal = useString("")
  const [replyComment, setReplyComment] = useState<
    ProjectBuildCommentDetail | null
  >(null)

  const handleReply = (comment: ProjectBuildCommentDetail) => {

    setReplyComment(comment)
  }

  const handleCancelReply = () => {
    setReplyComment(null)
  }

  useEffect(() => {
    setTimeout(() => {
      if (commentsPage > 1) {
        return
      }
      handleChangeScroll()
    }, 1000)
  }, [JSON.stringify(comments), commentsPage])

  const onSubmitButton = (dataEditor: string) => {
    if (!idProjectBuild || !workerUploadFile) {
      toast(
        <LabelNotificationPage
          messenger="The workerUploadFile is not working!"
          type="error"
        />
      )
      return
    }
    configureStore.dispatch(startLoading())
    isLoading.setValue(true)
    let newDataEditor = dataEditor
    listFileAdd
      .filter((item) => item.type === "inline")
      .forEach((item) => {
        newDataEditor = newDataEditor.replace(item.url || "", item.id)
      })
    postProjectCommentMiddleware(
      workerUploadFile,
      idProjectBuild,
      selectedApprove,
      {
        content: isEmpty(newDataEditor) ? dataEditorDefault : newDataEditor,
        files: listFileAdd.map((file) => {
          return {
            file: file.file,
            file_name: file.name,
            key: file.id ?? uuid(),
            type: file.type,
            file_type: file.file_type,
          }
        }),
        comment_from: replyComment?.id,
      },
      (type: STATUS_RESPONSE, messenger: string) => {
        isLoading.setValue(false)
        if (type === STATUS_RESPONSE.SUCCESS) {
          updateWhenCreateComment()
          setListFileAdd([])
          setDataEditor("")
          isScroll.setValue(true)
          clearStorageWhenSubmit()
          setSelectedApprove([])
          setReplyComment(null)
          openAddApprovalModal.setValue(false)
          searchApproveModal.setValue("")
        } else {
          closeLoading()
          toast(<LabelNotificationPage messenger={messenger} type={type} />)
        }
      }
    )
  }

  const onDisableButtonSubmit = () => {
    if (dataEditor !== dataEditorDefault || listFileAdd.length) {
      return false
    }
    return true
  }

  const handleToggleApprove = (id: string) => {
    setSelectedApprove((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const handleToggleApproveInModal = (id: string) => {
    setSelectedApprove((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const onAddApproval = () => {
    openAddApprovalModal.setValue(true)
    searchApproveModal.setValue("")
  }

  const handlrScrollCommmentFrom = (commentFromId: string) => {
    if (!commentFromId) {
      return
    }
    const el = document.getElementById(`msg-${commentFromId}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('highlight-message');
      setTimeout(() => el.classList.remove('highlight-message'), 2500);
    } else {
      loadMoreComments?.(commentFromId)
    }
  }

  const renderApproveEditor = () => {
    if (!approvers.length || !selectedApprove.length) {
      return <div />
    }
    return (
      <div className="flex items-center gap-[4px] w-full min-w-0">
        <p className="text-[12px] leading-[18px] font-medium">Approvals:</p>
        <div className="flex items-center gap-[4px] overflow-x-auto ml-[4px] flex-1 min-w-0">
          {selectedApprove.map((id) => {
            const userApprove = approvers.find((item) => item.id === id)
            if (!userApprove) {
              return null
            }
            return (
              <div
                key={id}
                className={`grid-card-editor-file-no-download card-editor-file mr-[4px] flex-shrink-0`}
                style={{
                  maxWidth: 200,
                }}
              >
                <Tippy
                  className="custom-tippy-menu-left"
                  placement="top"
                  content={
                    <span
                      className="font-normal"
                      style={{
                        fontSize: 13,
                        lineHeight: "22px",
                        wordBreak: "break-word",
                      }}
                    >
                      {userApprove.email}
                    </span>
                  }
                >
                  <div className="flex items-center">
                    <p
                      className="font-medium"
                      style={{
                        fontSize: 12,
                        lineHeight: "18px",
                        color: "#111111",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {userApprove.fullname}
                    </p>
                  </div>
                </Tippy>

                <div className="flex items-center justify-end change-color-icon-download-file">
                  <img
                    src={IconEditorDeleteFile}
                    alt="icon"
                    className="cursor-pointer ml-2"
                    onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      handleToggleApprove(id)
                    }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className="build-info-form flex flex-col justify-between h-full overflow-hidden">
      <div className="flex flex-1 flex-col overflow-auto pr-[24px]" ref={ref}
      >
        {hasMoreComments ? <div className="flex justify-center mb-4">
          <Button
            sizeBtn="small"
            title="Load more"
            colorBtn="white"
            onClick={() => loadMoreComments?.()}
            disabled={isLoadingMore}
            isDisabledBtn
          />
        </div> : null}
        {comments.length
          ? comments.map((comment, index) => {
            return (
              <CommentBuildItemCard
                key={`comment-${comment.id}-${index}`}
                comment={comment}
                idUserInfo={userInfo.id}
                subNameDownload={subNameDownload}
                isActiveComment={!isDeleted && !isEditorInput}
                onReply={handleReply}
                isOwner={isOwner}
                handlrScrollCommmentFrom={handlrScrollCommmentFrom}
              />
            )
          })
          : null}
      </div>

      {!isDeleted && !isEditorInput && (
        <div className="conversation-editor">
          <FormInputEditorCard
            handleChangeEditor={handleChangeEditor}
            dataEditor={dataEditor}
            fileSelectedHandler={fileSelectedHandler}
            listFileAdd={listFileAdd}
            keyInputFile={keyInputFile.value}
            handleDeleteFileNoDownload={handleDeleteFileNoDownload}
            onSubmitButton={onSubmitButton}
            onDisableButtonSubmit={onDisableButtonSubmit()}
            styleRoot={{
              height: "auto",
            }}
            approveEditor={approvers.length ? renderApproveEditor() : null}
            onAddApproval={onAddApproval}
            replyMessage={replyComment ? {
              id: replyComment.id,
              content: replyComment.content,
              user: {
                fullname: replyComment.user.fullname,
                email: replyComment.user.email,
              }
            } : null}
            onCancelReply={handleCancelReply}
            onScrollToReplyMessage={() => handlrScrollCommmentFrom(replyComment?.id || '')}
          />
        </div>
      )}
      {openAddApprovalModal.value && (
        <ModalCustom
          label="Add approval"
          widthModal={500}
          styleRoot={{
            width: isMobile ? "-webkit-fill-available" : 500,
          }}
          handleChangeButton={(key: ACTION_MODAL) => () => {
            openAddApprovalModal.setValue(false)
            searchApproveModal.setValue("")
          }}
          bodyChildren={
            <div className="flex flex-col">
              <div className="pb-[8px]">
                <div
                  className="flex items-center bg-[#F1F1F1] rounded-[4px] px-[8px] py-[4px]"
                  style={{
                    border: "1px solid #E4E4E4",
                  }}
                >
                  <IconSearchNormal
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 8,
                    }}
                  />
                  <InputDefault
                    value={searchApproveModal.value}
                    onChange={(e) => {
                      searchApproveModal.setValue(e.target.value)
                    }}
                    placeholder="Search by email or name"
                    style={{
                      border: "none",
                      boxShadow: "none",
                      background: "transparent",
                      height: 24,
                      fontSize: 12,
                      color: "#111111",
                      outline: "none",
                    }}
                    classCustom="flex-1 text-[12px] focus:outline-none focus:ring-0"
                  />
                </div>
              </div>
              <div
                style={{
                  overflow: "auto",
                  maxHeight: 400,
                }}
              >
                {approvers
                  .filter((userApprove) => {
                    if (!searchApproveModal.value.trim()) return true
                    const searchLower = searchApproveModal.value.toLowerCase()
                    const nameMatch = userApprove.fullname
                      ?.toLowerCase()
                      .includes(searchLower)
                    const emailMatch = userApprove.email
                      ?.toLowerCase()
                      .includes(searchLower)
                    return nameMatch || emailMatch
                  })
                  .map((elUserApprove) => {
                    const isSelected = includes(
                      selectedApprove,
                      elUserApprove.id
                    )
                    return (
                      <div
                        key={elUserApprove.id}
                        className="flex items-center gap-[8px] px-[8px] py-[8px] hover:bg-[#F7F7F7] rounded-[4px] cursor-pointer"
                        onClick={() =>
                          handleToggleApproveInModal(elUserApprove.id)
                        }
                      >
                        <CheckedDefault checked={isSelected} />
                        <div className="flex flex-col flex-1 min-w-0">
                          <p
                            className="font-medium text-[13px] leading-[22px] color-black-111111"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {elUserApprove.fullname}
                          </p>
                          <p
                            className="font-normal text-[12px] leading-[18px] color-gray-7a"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {elUserApprove.email}
                          </p>
                        </div>
                      </div>
                    )
                  })}
              </div>
            </div>
          }
        />
      )}
    </div>
  )
}
export default CommentsCard
